import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { typographyCss } from 'common/typography';

export type VenueCardProps = {
  venueDetails: Pick<Venue, 'name' | 'short_description' | 'listimage'>;
  banner?: React.ReactNode;
};

const Root = styled.div`
  border-radius: 24px;
  margin: 0 16px 16px;
  box-shadow: 0 0 12px 0 ${cssThemedValue({ light: colors.pepper12, dark: colors.salt12 })};
  overflow: hidden;
`;

const Image = styled.img`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 192px;
  object-fit: cover;
  background-color: ${cssThemedValue({ light: colors.pepper8, dark: colors.salt12 })};
`;

const Content = styled.div`
  padding: 16px;
`;

const Title = styled.h3`
  ${typographyCss.Heading4}
  margin-block-start: 0;
  margin-block-end: 16px;
`;

const Description = styled.p`
  ${typographyCss.Body3}
  margin-block-start: 0;
  margin-block-end: 12px;
`;

const VenueCard = ({ venueDetails, banner }: VenueCardProps) => {
  const { locale } = useIntl();
  const { name, short_description, listimage } = venueDetails;

  const activeLang = locale as Language;
  const title = name.find(({ lang }) => lang === activeLang)?.value;
  const shortDescription = short_description.find(({ lang }) => lang === activeLang)?.value;

  return (
    <Root>
      {!!listimage && <Image src={listimage} alt={title} />}
      <Content>
        <Title>{title}</Title>
        {!!shortDescription && <Description>{!!shortDescription}</Description>}
        {banner}
      </Content>
    </Root>
  );
};

export default VenueCard;
